import React, { FC } from "react";
import { Redirect, Route } from "react-router-dom";
import { Loader } from "../components/UI/Loader";
import { useStore } from "../hooks/useStore";
import { useUser } from "../hooks/query/useUser";
import { boot as bootIntercom } from "../config/intercom";
import { hasToken } from "../@vars/acessToken";

interface ProtectedRouteProps {
  component: any;
  path: string;
  props?: any;
}

export const ProtectedRoute: FC<ProtectedRouteProps> = ({
  component: Component,
  path,
  props,
}) => {
  const { user, loading } = useUser();
  const { logoutLoading } = useStore();

  if (loading) return <Loader />;
  if (user) {
    bootIntercom({
      email: user.email,
      name: user.fullname.split(" ")[0],
      phone: user.phone,
      country: user.country,
    });
  }
  if (logoutLoading) return <Loader />;
  return hasToken() ? (
    <Route exact path={path}>
      <Component user={user} {...props} />
    </Route>
  ) : (
    <Redirect to={{ pathname: "/login" }} />
  );
};
